<template>
  <span :id="slice.primary.anchor_id || ''"></span>
</template>
<script>
export default {
  name: 'AnchorId',
  props: {
    slice: {
      type: Object,
      required: true
    }
  }
};
</script>
